import { Injectable } from '@angular/core';
import { ShapeModel } from '../../../base/shape/model/shape.mdl';
import { AbstractCommand, Command, ModalController, StateService } from 'flux-core';
import { IDialogBoxData, PlanPermission } from 'flux-definition';
import { UpgradeDialogType, UpgradeDialogWindow } from 'flux-user';
import { LibraryList } from '../../ui/temp-add-libs-menu/library-list';
import { DiagramLocatorLocator } from '../../../base/diagram/locator/diagram-locator-locator';
import { DefinitionLocator } from '../../../base/shape/definition/definition-locator.svc';
import { fromPromise } from 'rxjs/internal-compatibility';
import { PlanPermManager } from '../../../base/permission/plan-perm-manager';

@Injectable()
@Command()
export class CheckPremiumShapeLimitations extends AbstractCommand {

    public data: {
        shapes: { [key: string]: ShapeModel },
    };

    public static readonly maxPremiumShapesCount = 10;

    constructor(
        protected libraryList: LibraryList,
        protected planPermManager: PlanPermManager,
        protected modalController: ModalController,
        protected state: StateService<any, any>,
        protected ll: DiagramLocatorLocator,
        protected defL: DefinitionLocator,
    ) {
        super();
    }

    public execute() {
        return fromPromise( this.executePromise());
    }

    protected async executePromise(): Promise<boolean> {
        const diagram = await this.ll.forCurrent( false ).getDiagramOnce().toPromise();
        const shapes = this.data.shapes;
        for ( const shapeId in shapes ) {
            const currentShape = shapes[shapeId];
            const currentShapeLibraryId = currentShape.defId.split( '.' )[1];
            const isPremiumShapeInDef = await this.isPremiumShapeInDef( currentShape );
            const isPremiumShape =  isPremiumShapeInDef || this.libraryList.belongsToPremiumGroup( currentShapeLibraryId );
            currentShape.premium = isPremiumShape;
            if ( isPremiumShape && ( diagram.premiumShapesCount >= CheckPremiumShapeLimitations.maxPremiumShapesCount ) 
                && !this.planPermManager.check([ PlanPermission.CREATELY_PREMIUM_LIBRARIES ])) {
                    if (currentShapeLibraryId === 'org-chart' || currentShapeLibraryId === 'genogram-medical' || currentShapeLibraryId === 'genogram-colored' || currentShapeLibraryId === 'genogram-gender-based') {
                        this.showUpgradeDialog({ shapeLibraryId: currentShapeLibraryId });
                      } else if (currentShapeLibraryId === 'genogram') {
                        this.showUpgradeDialog({ shapeDefId: currentShape.defId });
                      } else {
                        this.showUpgradeDialog({ shapeLibraryId: currentShapeLibraryId });
                      }
                throw new Error( 'Permission is denied' );
            }
        }
        this.resultData = this.data;
        return true;
    }

    protected async isPremiumShapeInDef( shape ) {
        const def = await this.defL.getDefinition( shape.defId, shape.version ).toPromise();
        return ( def as any ).premium;
    }

    /**
     * Showing the upgradeDialog
     */
    protected showUpgradeDialog(opts: { shapeLibraryId?: string; shapeDefId?: string }) {
        const dialogData = {
            id: PlanPermission.CREATELY_PREMIUM_LIBRARIES,
            iframeType: UpgradeDialogType.PremiumShape,
            buttons: [
                {
                    type: 'upgrade',
                    clickHandler: () => {},
                },
            ],
            integrationContext: {
                embedded: this.state.get( 'ApplicationIsEmbedded' ),
                environment: this.state.get( 'PluginApp' ),
            },
            shapeLibraryId: opts.shapeLibraryId,
            shapeDefId: opts.shapeDefId,
        } as IDialogBoxData;

        this.modalController.show( UpgradeDialogWindow, {
            inputs: {
                dialogData,
            },
        });
    }

}

Object.defineProperty( CheckPremiumShapeLimitations, 'name', {
    value: 'CheckPremiumShapeLimitations',
});
